import React from 'react';
import ReactDOM from 'react-dom';

const AnalysisPopup = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target instanceof HTMLElement && e.target.id === 'popup') {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div
      className="fixed bottom-0 left-0 right-0 top-0 z-[800] flex items-center justify-center bg-[rgba(0,0,0,0.85)]"
      onMouseDown={handleMouseDown}
      id="popup"
    >
      <div className="text-center" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.getElementById('portal-root')
  );
};

export default AnalysisPopup;
